// extracted by mini-css-extract-plugin
export default {"tooltip":"EA-z","arrow":"FA-z"};